module.exports = __webpack_public_path__ + "img/17.9484c2d6.jpg";